import injectSheet from 'react-jss'
import BackButton from './BackButton'
import styles from './BackButton.styles'

export default injectSheet(styles)(BackButton)
